<template>
<div class="usp-section">
  <div class="container">
  <h2 class="font-size-custom-max-32">Dit is wat ons onderscheidt</h2>
  <ejs-accordion expandMode='Single'>
    <e-accordionitems>
    <e-accordionitem expanded='true' header='1. Specialisten, geen generalisten' content='Vakidioten, met dat woord omschrijf je ons het beste. Wij selecteren bij iedere samenwerking de beste man/vrouw voor de job. Binnen ons kleine team heeft iedereen een specialisme, en dat is ook nodig.'></e-accordionitem>
    <e-accordionitem header='2. Kennis delen' content='Zoals een van onze relaties altijd zegt; delen is het nieuwe vermenigvuldigen. Hier geloven wij ook heilig in. Zodra je zaken voor jezelf gaat houden communiceer je niet volledig vanuit je kracht. Wij delen liever te veel dan te weinig en verwachten dat ook andersom.'></e-accordionitem>
    <e-accordionitem header='3. Eigenwijs, wen daar maar aan' content='Oke, wij zullen nooit onnodig eigenwijs zijn. Maar we hebben een duidelijke kijk op de wereld. Vertrouwen is hierbij een belangrijke pijler. Zodra je met ons samenwerkt kom je er achter wanneer wij eigenwijs zijn en wanneer wij water bij de wijn doen..'></e-accordionitem>
    <e-accordionitem header='4. Co-worken is key' content='Samenwerken betekent samen werken. Zodra wij alleen op afstand kunnen werken en er geen persoonlijk contact is vinden wij het niet eens leuk om samen te werken. De klik, de chemie die maakt het werk leuk. Dus af en toe bij elkaar zijn en successen vieren hoort daarbij.'></e-accordionitem>
    <e-accordionitem header='5. Werken met maatschappelijk bewuste organisaties' content='Maatschappelijk bewust betekend niet dat we alleen met goede doelen werken. Maar je moet hier niet voor jezelf zijn. Het liefst werken wij met organisaties die begrijpen wat ze voor een ander betekenen.'></e-accordionitem>
    </e-accordionitems>
  </ejs-accordion>
  </div>
</div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
@import "../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-vue-navigations/styles/material.css";

.e-accordion {
  background: transparent !important;
  max-width: 500px;
  border: none;
}

.usp-section{
  background-color: $yellow;
  min-height: 550px;
  padding-bottom: 150px;

    h2{
      padding-top: layout-val-64(2);
      padding-bottom: layout-val-8(2);
    }
}
</style>